import { Outlet } from "react-router-dom";

export default function SurveyOutlet() {
  return <Outlet />;
}
